
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-care",
      function () {
        return require("private-next-pages/get-care/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-care"])
      });
    }
  